var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "800px",
        height: "800px",
        viewBox: "0 0 21 21",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        fill: "#F09A0FFF",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("title", [_vm._v("profile_image_close_round [#F09A0FFF]")]),
        _vm._v(" "),
        _c("desc", [_vm._v("Created with Sketch.")]),
        _vm._v(" "),
        _c("defs"),
        _vm._v(" "),
        _c(
          "g",
          {
            attrs: {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: "none",
              "fill-rule": "evenodd",
            },
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "Dribbble-Light-Preview",
                  transform: "translate(-300.000000, -2199.000000)",
                  fill: "#F09A0FFF",
                },
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "icons",
                      transform: "translate(56.000000, 160.000000)",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M264.712423,2058.32983 C265.095859,2058.71234 265.095859,2059.33159 264.712423,2059.71312 C264.328987,2060.09563 263.708232,2060.09563 263.325776,2059.71312 L262.632453,2059.02148 L261.939129,2059.71312 C261.555693,2060.09563 260.934938,2060.09563 260.551502,2059.71312 C260.169046,2059.33159 260.169046,2058.71234 260.551502,2058.32983 L261.244825,2057.63819 L260.551502,2056.94654 C260.169046,2056.56404 260.169046,2055.94479 260.551502,2055.56326 C260.934938,2055.18075 261.555693,2055.18075 261.939129,2055.56326 L262.632453,2056.2549 L263.325776,2055.56326 C263.708232,2055.18075 264.328987,2055.18075 264.712423,2055.56326 C265.095859,2055.94479 265.095859,2056.56404 264.712423,2056.94654 L264.019099,2057.63819 L264.712423,2058.32983 Z M254.417502,2048.71725 C253.841858,2048.6703 253.673185,2048.67812 253.185799,2048.71432 C251.860934,2048.42964 250.864588,2047.25375 250.864588,2045.84796 C250.864588,2044.22988 252.183569,2042.91312 253.806554,2042.91312 C255.428558,2042.91312 256.74852,2044.22988 256.74852,2045.84796 C256.74852,2047.25668 255.747271,2048.43551 254.417502,2048.71725 L254.417502,2048.71725 Z M245.973079,2055.68848 C245.971117,2055.66793 245.961311,2055.6513 245.961311,2055.63076 L245.961311,2041.93484 C245.961311,2041.39483 246.399664,2040.95656 246.941966,2040.95656 L253.743792,2040.95656 C251.064642,2040.9908 248.903277,2043.16552 248.903277,2045.84502 C248.903277,2047.25864 249.513245,2048.52258 250.473306,2049.41575 C248.026571,2050.54957 246.261391,2052.89549 245.973079,2055.68848 L245.973079,2055.68848 Z M253.869316,2040.95656 L260.671142,2040.95656 C261.212464,2040.95656 261.651797,2041.39483 261.651797,2041.93484 L261.651797,2050.73936 C261.651797,2051.27937 262.09015,2051.71764 262.632453,2051.71764 C263.173774,2051.71764 263.613108,2051.27937 263.613108,2050.73936 L263.613108,2040.95656 C263.613108,2039.87654 262.734441,2039 261.651797,2039 L245.961311,2039 C244.877687,2039 244,2039.87654 244,2040.95656 L244,2056.60904 C244,2057.69004 244.877687,2058.5656 245.961311,2058.5656 L255.767865,2058.5656 C256.309187,2058.5656 256.74852,2058.12733 256.74852,2057.58732 C256.74852,2057.04731 256.309187,2056.60904 255.767865,2056.60904 L247.897125,2056.60904 C247.897125,2056.60904 247.891241,2056.54447 247.891241,2056.50534 C247.891241,2053.47659 250.202645,2050.98295 253.158341,2050.67479 C254.138996,2050.8049 255.829646,2050.39403 256.954458,2051.43687 C257.935113,2052.34569 259.416884,2050.89099 258.313646,2050.10935 C257.939036,2049.84423 257.538929,2049.60945 257.116266,2049.41085 C258.089076,2048.51768 258.709831,2047.25962 258.709831,2045.83524 C258.709831,2043.15573 256.547486,2040.9908 253.869316,2040.95656 L253.869316,2040.95656 Z",
                        id: "profile_image_close_round-[#F09A0FFF]",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }